import React, { Component } from 'react';
import { graphql, StaticQuery } from 'gatsby';
import ReactHtmlParser from 'react-html-parser';
import * as Scroll from 'react-scroll';
import LazyLoad, { forceCheck } from 'react-lazyload';
import {
  Section,
  Image,
  Heading,
  Paragraph,
  Link,
  SliderArrow,
  Button,
  Icon,
  IconSVG,
  Container,
} from 'components';
import './awwwards-slider.scss';
import { Col, Row } from 'react-flexbox-grid';
import Slider from 'react-slick';
import { ICON_TYPES } from 'config';
import { data } from './logic.js';
import MobileSlides from './mobileSlider';

class Slides extends Component {
  static sliderSettings = {
    className: 'wdm__awards-slider',
    speed: 1000,
    arrows: true,
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    variableWidth: true,
    nextArrow: (
      <SliderArrow id={'wdm__slider-next'} color={'black'} defaultClasses />
    ),
    prevArrow: (
      <SliderArrow
        id={'wdm__slider-prev'}
        color={'black'}
        left
        defaultClasses
      />
    ),
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  constructor(props) {
    super(props);

    this.state = {
      currentSlide: 0,
      slideExpanded: false,
      isMobile: false,
    };
  }

  componentDidMount() {
    this.handleResize();

    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    this.setState({ isMobile: window.innerWidth < 768 });
  };

  handleExpandClick = () => {
    this.setState({ slideExpanded: true });
    setTimeout(forceCheck, 1);
  };

  handleCloseSlide = index => {
    this.setState({ slideExpanded: false, currentSlide: index });
  };

  renderNavigation = () =>
    data.map((item, index) => {
      const { color, name } = item;

      return (
        <li
          id={`awwwards-slider-navi-${index}`}
          className={`showcase-navi__item showcase-navi__item--${color} ${
            this.state.currentSlide === index ? 'active' : ''
          }`}
          onClick={() => this.handleCloseSlide(index)}
        >
          <p className={'showcase-navi__title'}>{ReactHtmlParser(name)}</p>
        </li>
      );
    });

  renderSlides = () =>
    data.map(item => {
      const {
        id,
        name,
        tags,
        cover,
        photo01,
        photo02,
        photo03,
        alt01,
        alt02,
        alt03,
        flag,
        color,
        description,
        caseStudyName,
        caseStudyLink,
        indigoAward,
        awwwards,
      } = item;
      const { isMobile, currentSlide, slideExpanded } = this.state;

      return (
        <StaticQuery
          query={graphql`
            fragment coverFields on File {
              childImageSharp {
                fluid(maxWidth: 1440, quality: 95) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }

            fragment flagFields on File {
              childImageSharp {
                fixed(width: 20) {
                  ...GatsbyImageSharpFixed_withWebp
                }
              }
            }

            fragment photoFields on File {
              childImageSharp {
                fixed(height: 600) {
                  ...GatsbyImageSharpFixed_withWebp
                }
              }
            }

            fragment photoFields2 on File {
              childImageSharp {
                fixed(height: 514) {
                  ...GatsbyImageSharpFixed_withWebp
                }
              }
            }

            query {
              # Icons
              Awwwards: file(
                relativePath: { eq: "awards/logo-awwwards.png" }
              ) {
                childImageSharp {
                  fixed(height: 15) {
                    ...GatsbyImageSharpFixed_withWebp
                  }
                }
              }
              Indigo: file(relativePath: { eq: "awards/logo-indigo.png" }) {
                childImageSharp {
                  fixed(width: 90) {
                    ...GatsbyImageSharpFixed_withWebp
                  }
                }
              }
              # Covers
              VirginRadioOman: file(
                relativePath: { eq: "why-design-matters/01_Virgin/main.jpg" }
              ) {
                ...coverFields
              }
              EresYachting: file(
                relativePath: { eq: "why-design-matters/02_Eres/main.jpg" }
              ) {
                ...coverFields
              }
              TealWorkSpace: file(
                relativePath: { eq: "why-design-matters/03_Teal/main.jpg" }
              ) {
                ...coverFields
              }
              A2I: file(
                relativePath: { eq: "why-design-matters/04_A2I/main.jpg" }
              ) {
                ...coverFields
              }
              Oneida: file(
                relativePath: { eq: "why-design-matters/05_Oneida/main.jpg" }
              ) {
                ...coverFields
              }
              # Flags
              Oman: file(
                relativePath: { eq: "why-design-matters/flags/Oman.png" }
              ) {
                ...flagFields
              }
              Polska: file(
                relativePath: { eq: "why-design-matters/flags/polska.png" }
              ) {
                ...flagFields
              }
              Saudi: file(
                relativePath: { eq: "why-design-matters/flags/saudi.png" }
              ) {
                ...flagFields
              }
              Swiss: file(
                relativePath: { eq: "why-design-matters/flags/swiss.png" }
              ) {
                ...flagFields
              }
              USA: file(
                relativePath: { eq: "why-design-matters/flags/USA.png" }
              ) {
                ...flagFields
              }
              # Photos
              VirginRadioOman01: file(
                relativePath: { eq: "why-design-matters/01_Virgin/01.jpg" }
              ) {
                ...photoFields
              }

              VirginRadioOman02: file(
                relativePath: { eq: "why-design-matters/01_Virgin/02.jpg" }
              ) {
                ...photoFields2
              }

              VirginRadioOman03: file(
                relativePath: { eq: "why-design-matters/01_Virgin/03.jpg" }
              ) {
                ...photoFields
              }

              EresYachting01: file(
                relativePath: { eq: "why-design-matters/02_Eres/01.jpg" }
              ) {
                ...photoFields
              }

              EresYachting02: file(
                relativePath: { eq: "why-design-matters/02_Eres/02.jpg" }
              ) {
                ...photoFields2
              }

              EresYachting03: file(
                relativePath: { eq: "why-design-matters/02_Eres/03.jpg" }
              ) {
                ...photoFields
              }

              TealWorkSpace01: file(
                relativePath: { eq: "why-design-matters/03_Teal/01.jpg" }
              ) {
                ...photoFields
              }

              TealWorkSpace02: file(
                relativePath: { eq: "why-design-matters/03_Teal/02.jpg" }
              ) {
                ...photoFields2
              }

              TealWorkSpace03: file(
                relativePath: { eq: "why-design-matters/03_Teal/03.jpg" }
              ) {
                ...photoFields
              }

              A2I01: file(
                relativePath: { eq: "why-design-matters/04_A2I/01.jpg" }
              ) {
                ...photoFields2
              }

              A2I02: file(
                relativePath: { eq: "why-design-matters/04_A2I/02.jpg" }
              ) {
                ...photoFields2
              }

              A2I03: file(
                relativePath: { eq: "why-design-matters/04_A2I/03.jpg" }
              ) {
                ...photoFields2
              }

              Oneida01: file(
                relativePath: { eq: "why-design-matters/05_Oneida/01.jpg" }
              ) {
                ...photoFields
              }

              Oneida02: file(
                relativePath: { eq: "why-design-matters/05_Oneida/02.jpg" }
              ) {
                ...photoFields2
              }

              Oneida03: file(
                relativePath: { eq: "why-design-matters/05_Oneida/03.jpg" }
              ) {
                ...photoFields
              }
            }
          `}
          render={loadedData => (
            <>
              {isMobile ? (
                <div
                  className={`slide__container slide__container--mobile ${
                    currentSlide + 1 == id ? 'active' : 'off'
                  }`}
                >
                  <div className="coverslide__wrapper">
                    <Image
                      src={loadedData[cover].childImageSharp.fluid}
                      additionalClass="coverslide__photo"
                      style={{
                        objectPosition: 'top left',
                      }}
                    />
                    <div className={'coverslide__details'}>
                      <h3 className={'coverslide__title'}>{name}</h3>
                      <p className={'coverslide__tags'}>{tags}</p>
                      <Button
                        id={`expand-portfolio--${id}`}
                        color={'white'}
                        transparent
                        onClick={() => this.handleExpandClick(id)}
                      >
                        See more
                      </Button>
                    </div>
                  </div>
                  <div
                    className={`expanded__wrapper expanded__wrapper--${id} ${
                      slideExpanded === true ? 'active' : 'off'
                    }`}
                  >
                    <div className={'expanded__wrapper--scroll'}>
                      <div className={'expanded__description-container'}>
                        <span
                          className={`expanded__id expanded__id--${color}`}
                        >
                          0{id}.
                        </span>
                        <h3 className={'expanded__title anim-fade-in'}>
                          {name}
                        </h3>
                        <LazyLoad once offset={200} height={280} overflow>
                          <MobileSlides photos={[photo01, photo02, photo03]} />
                        </LazyLoad>
                        <Paragraph
                          additionalClass={'expanded__text text--light'}
                        >
                          {description}
                        </Paragraph>
                      </div>
                      <div
                        className={`slide-arrow expanded__go-back wdm__awards-slider`}
                        role={'presentation'}
                        id={id}
                        onClick={() => this.handleCloseSlide(id - 1)}
                      >
                        <IconSVG name={'arrow-left'} color={'black'} />
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  className={`slide__container ${
                    currentSlide + 1 == id ? 'active' : 'off'
                  }`}
                >
                  <div className="coverslide__wrapper">
                    <Image
                      src={loadedData[cover].childImageSharp.fluid}
                      additionalClass="coverslide__photo"
                      style={{
                        objectPosition: 'top left',
                      }}
                    />

                    <div className={'coverslide__details'}>
                      <Image
                        src={loadedData[flag].childImageSharp.fixed}
                        alt="Country"
                        type="fixed"
                        additionalClass="expanded__media-flag"
                      />
                      <h3 className={'coverslide__title'}>{name}</h3>
                      <p className={'coverslide__tags'}>{tags}</p>
                      <Button
                        id={`expand-portfolio--${id}`}
                        color={'white'}
                        transparent
                        onClick={() => this.handleExpandClick(id)}
                      >
                        See more
                      </Button>
                    </div>
                  </div>
                  <div
                    className={`expanded__wrapper expanded__wrapper--${id} ${
                      slideExpanded === true ? 'active' : 'off'
                    }`}
                  >
                    <div className={'expanded__wrapper--scroll'}>
                      <Slider
                        ref={slider => {
                          this.slider = slider;
                        }}
                        {...this.constructor.sliderSettings}
                      >
                        <div className={'expanded__description-container'}>
                          <span
                            className={`expanded__id expanded__id--${color}`}
                          >
                            0{id}.
                          </span>
                          <h3 className={'expanded__title anim-fade-in'}>
                            {name}
                          </h3>
                          <p className={'expanded__text'}>
                            {description}
                            {caseStudyLink && (
                              <div className={'expanded__info'}>
                                Read the full case study:&nbsp;
                                <Link
                                  to={caseStudyLink}
                                  className={`expanded__cs-link text--bold u-color--${color}`}
                                  id={`case-study-${name}`}
                                >
                                  <span
                                    id={`why-design-matters__${caseStudyName}`}
                                  >
                                    {caseStudyName}
                                  </span>
                                </Link>
                              </div>
                            )}
                            <div className={'expanded__cs-awwwards'}>
                              {awwwards && (
                                <div className={'expanded__info'}>
                                  <Link to={awwwards} id={`awwwards-${name}`}>
                                    <Image
                                      src={
                                        loadedData.Awwwards.childImageSharp
                                          .fixed
                                      }
                                      type="fixed"
                                    />
                                  </Link>
                                </div>
                              )}
                              {indigoAward && (
                                <div className={'expanded__info'}>
                                  <Link
                                    to={indigoAward}
                                    id={`indigo-award-${name}`}
                                  >
                                    <Image
                                      src={
                                        loadedData.Indigo.childImageSharp.fixed
                                      }
                                      type="fixed"
                                    />
                                  </Link>
                                </div>
                              )}
                            </div>
                          </p>
                        </div>
                        <LazyLoad once offset={500} height={600}>
                          <Image
                            src={loadedData[photo01].childImageSharp.fixed}
                            alt={alt01}
                            additionalClass={'expanded__media-item'}
                            type="fixed"
                          />
                        </LazyLoad>
                        <LazyLoad once offset={500} height={600}>
                          <Image
                            src={loadedData[photo02].childImageSharp.fixed}
                            alt={alt02}
                            additionalClass={'expanded__media-item'}
                            type="fixed"
                          />
                        </LazyLoad>
                        <LazyLoad once offset={500} height={600}>
                          <Image
                            src={loadedData[photo03].childImageSharp.fixed}
                            alt={alt03}
                            additionalClass={'expanded__media-item'}
                            type="fixed"
                          />
                        </LazyLoad>
                      </Slider>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        />
      );
    });

  render() {
    const { currentSlide } = this.state;

    return (
      <div>
        <div className={`slider__slides slide-${currentSlide + 1}`}>
          {this.renderSlides()}
        </div>
        <div className={'showcase-scroll'}>
          <ul className={'showcase-navi'}>{this.renderNavigation()}</ul>
        </div>
      </div>
    );
  }
}

class AwwwardsSlider extends Component {
  render() {
    const SpyLink = Scroll.Link;

    return (
      <Section additionalClass={'showcase showcase--no-padding'} fullwidth>
        <Container>
          <Row>
            <Col sm={12} md={4}>
              <Heading
                type={2}
                size={'large'}
                additionalClass={'showcase__title'}
              >
                5 great Boldare designs
              </Heading>
            </Col>
            <Col sm={12} md={6} mdOffset={2}>
              <p className={'showcase__text paragraph--regular text--default'}>
                The following are just five examples of Boldare’s commercial
                design work for clients around the world. From
                culture-expanding radio to chartering luxury yachts to a
                virtual place setting app for choosing tableware, no matter the
                function, we firmly believe design is crucial to a successful
                app. Here are five examples of excellent Boldare design we’ve
                produced for our clients, and the technologies we used.
              </p>
              <SpyLink
                id={'awwwards-slider-see-examples'}
                activeClass="active"
                to={'awwwards-slides'}
                spy
                smooth
                offset={0}
                duration={500}
                className={'showcase__go-next'}
              >
                <Paragraph color={'white'} additionalClass={'text--bold'}>
                  See examples
                </Paragraph>
                <Icon
                  icon={ICON_TYPES.RIGHT_ARROW}
                  size={'medium'}
                  color={'white'}
                />
              </SpyLink>
            </Col>
          </Row>
        </Container>
        <Section
          id={'awwwards-slides'}
          fullwidth
          additionalClass={'showcase--no-padding'}
        >
          <Slides />
        </Section>
      </Section>
    );
  }
}

export default AwwwardsSlider;
